module.exports = __webpack_public_path__ + "static/media/alert-close.997d8101.svg";